import { render, staticRenderFns } from "./UserProfileIcon.vue?vue&type=template&id=6692e9fc"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6692e9fc')) {
      api.createRecord('6692e9fc', component.options)
    } else {
      api.reload('6692e9fc', component.options)
    }
    module.hot.accept("./UserProfileIcon.vue?vue&type=template&id=6692e9fc", function () {
      api.rerender('6692e9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/UserProfileIcon.vue"
export default component.exports